import React, { useEffect, useState } from "react";
import urls from "../../../Utils/urls";
import axios from "../../../axios";
import axiosInstance from "axios";
import useBorrowerDashboardTwo from "../BorrowerDashboardTwo/apis/useBorrowerDashboardTwo";
import { oracleConfig } from "../../../Utils/constant";

const useAchData = (
  accountIds,
  activeTab,
  singleAccount,
  setValue,
  accountId,
  refresh,
) => {
  const [achData, setAchData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [enrolledLoansCount, setEnrolledLoansCount] = useState(0);
  const [notEnrolledLoansCount, setNotEnrolledLoansCount] = useState(0);
  const [enrolledLoanData, setEnrolledLoanData] = useState(null);
  const [secondLoader, setSecondLoader] = useState(false);
  const { activeAccountList } = useBorrowerDashboardTwo();

  // axiosInstance.interceptors.response.use(
  //   (response) => {
  //     if (response.data.loans) {
  //       // 🔁 Modify values here
  //       const data = response.data.loans.map((item, idx) => {
  //         if (idx === 0) {
  //           return {
  //             ...item,
  //             DISABLE_YN: "Y",
  //           };
  //         } else return item;
  //       });

  //       response.data.loans = data;
  //     }

  //     return response;
  //   },
  //   (error) => Promise.reject(error)
  // );

  useEffect(() => {
    // if (!accountIds.length && !singleAccount) return;
    const fetchData = async () => {
      setLoading(true);
      try {
        const responses = await axios.get(
          urls.borrower.getPaymentsLoanAchInfo(accountId),
        );

        const allData = responses.data[0];

        allData.forEach((item, index) => {
          setValue(`row[${index}].achDebitAmount`, item?.ACH_DebitAmount);
          setValue(`row[${index}].loanNumber`, accountId);
          setValue(`row[${index}].achStopDate`, item?.ACH_StopDate);
          setValue(`row[${index}].selectedIndex`, index);
          setValue(
            `row[${index}].loan_account_number`,
            item?.loan_account_number,
          );
          setValue(
            `row[${index}].ACH_IndividualName`,
            item?.ACH_IndividualName,
          );
          setValue(
            `row[${index}].loan_account`,
            `${item?.loan_account_number} - ${item?.ACH_IndividualName}`,
          );
        });
        setAchData(allData);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching ACH info:", err);
        setLoading(false);
      }
    };

    // if (accountId && singleAccount) {
    //   fetchData();
    // }
    if (accountId && singleAccount && refresh) {
      fetchData();
    }
    if (accountId && singleAccount && !refresh) {
      fetchData();
    }
  }, [accountId, singleAccount, refresh]);

  useEffect(() => {
    if (!accountIds?.length) return;

    if (activeTab !== null && accountIds?.length) {
      async function fetchFilteredACHDataSql() {
        setLoading(true);
        try {
          const requestBody = {
            RecID: accountIds.join(","),
            service_status: tabButtons[activeTab]?.key,
          };
          const res = await axios.post(
            urls.borrower.getAchDetailsSQL,
            requestBody,
          );

          const data = res?.data?.[0].map((item, index) => {
            setValue(`row[${index}].achDebitAmount`, item?.ACH_DebitAmount);
            setValue(`row[${index}].loanNumber`, item?.recid);
            setValue(`row[${index}].achStopDate`, item?.ACH_STOPDATE);
            setValue(`row[${index}].selectedIndex`, index);
            setValue(
              `row[${index}].loan_account_number`,
              item?.ACH_ACCOUNTNUMBER,
            );
            setValue(
              `row[${index}].ACH_IndividualName`,
              item?.ACH_INDIVIDUALNAME,
            );
            setValue(
              `row[${index}].loan_account`,
              `${item?.ACH_INDIVIDUALID} - ${item?.ACH_INDIVIDUALNAME}`,
            );

            return item || null;
          });

          setAchData(data);
          setLoading(false);
        } catch (error) {
          console.error(error);
          setLoading(false);
        }
      }

      fetchFilteredACHDataSql();
    }
  }, [activeTab, accountIds?.length, refresh]);

  // useEffect(() => {
  //   if (!accountIds?.length) return;

  //   if (activeTab !== null && accountIds?.length) {
  //     async function fetchFilteredACHData() {
  //       setLoading(true);
  //       try {
  //         const requestBody = {
  //           RecID: accountIds.join(","),
  //         };
  //         const res = await axiosInstance.post(
  //           urls.borrower.filteredACHData(tabButtons[activeTab]?.key),
  //           requestBody,
  //           header
  //         );
  //         // const requestBody = {
  //         //   JsonInput: accountIds.join(" "),
  //         //   ACH_ServiceStatus: tabButtons[activeTab].key,
  //         // };
  //         // const res = await axiosInstance.post(
  //         //   urls.borrower.borrowerAchDetails,
  //         //   requestBody
  //         // );

  //         const data = res.data.loans.map((item, index) => {
  //           setValue(`row[${index}].achDebitAmount`, item?.ACH_DEBIT_AMOUNT);
  //           setValue(`row[${index}].loanNumber`, item?.recid);
  //           setValue(`row[${index}].achStopDate`, item?.ACH_STOPDATE);
  //           setValue(`row[${index}].selectedIndex`, index);
  //           setValue(
  //             `row[${index}].loan_account_number`,
  //             item?.ACH_ACCOUNTNUMBER
  //           );
  //           setValue(
  //             `row[${index}].ACH_IndividualName`,
  //             item?.ACH_INDIVIDUALNAME
  //           );
  //           setValue(
  //             `row[${index}].loan_account`,
  //             `${item?.ACH_INDIVIDUALID} - ${item?.ACH_INDIVIDUALNAME}`
  //           );

  //           return item || null;
  //         });

  //         setAchData(data);
  //         setLoading(false);
  //       } catch (error) {
  //         console.error(error);
  //         setLoading(false);
  //       }
  //     }

  //     fetchFilteredACHData();
  //   }
  // }, [activeTab, accountIds?.length, refresh]);

  useEffect(() => {
    async function getFilteredACHData() {
      setSecondLoader(true);
      try {
        const requestBody = {
          RecID: activeAccountList?.map((el) => el.value)?.join(","),
        };

        const keys = [1, 0];
        const res = await Promise.all(
          keys.map((el) =>
            axiosInstance.post(
              urls.borrower.filteredACHData(el),
              requestBody,
              oracleConfig,
            ),
          ),
        );

        setEnrolledLoanData(res[0]?.data?.loans);
        setEnrolledLoansCount(res[0]?.data?.loans?.length);
        setNotEnrolledLoansCount(res[1]?.data?.loans?.length);

        setSecondLoader(false);
      } catch (error) {
        console.error(error);
        setSecondLoader(false);
      }
    }
    if (activeAccountList?.length) {
      getFilteredACHData();
    }
  }, [activeAccountList?.length]);

  async function fetchACHData(accountId) {
    setLoading(true);
    try {
      const responses = await axios.get(
        urls.borrower.getPaymentsLoanAchInfo(accountId),
      );

      const allData = responses.data[0];

      setAchData(allData);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching ACH info:", err);
      setLoading(false);
    }
  }

  async function getFilteredACHData() {
    setSecondLoader(true);
    try {
      const requestBody = {
        RecID: activeAccountList?.map((el) => el.value)?.join(","),
      };

      const keys = [1, 0];
      const res = await Promise.all(
        keys.map((el) =>
          axiosInstance.post(
            urls.borrower.filteredACHData(el),
            requestBody,
            oracleConfig,
          ),
        ),
      );

      setEnrolledLoanData(res[0]?.data?.loans);
      setEnrolledLoansCount(res[0]?.data?.loans?.length);
      setNotEnrolledLoansCount(res[1]?.data?.loans?.length);

      setSecondLoader(false);
    } catch (error) {
      console.error(error);
      setSecondLoader(false);
    }
  }

  return {
    achData,
    loading,
    fetchACHData,
    enrolledLoansCount,
    notEnrolledLoansCount,
    enrolledLoanData,
    getFilteredACHData,
    secondLoader
  };
};

export default useAchData;

const tabButtons = [
  { label: <p>Scheduled Loans</p>, title: "Scheduled Loans", key: 1 },
  { label: <p>Non scheduled Loans</p>, title: "Non scheduled Loans", key: 0 },
];
